import { render, staticRenderFns } from "./ticketDetails.vue?vue&type=template&id=45524026"
import script from "./ticketDetails.vue?vue&type=script&lang=js"
export * from "./ticketDetails.vue?vue&type=script&lang=js"
import style0 from "./ticketDetails.vue?vue&type=style&index=0&id=45524026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports